import {
    LEAVE_REQUEST_TYPES,
    type LeaveRequestType,
} from "@/features/requests/types";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

type ReasonFieldProps = {
    value: LeaveRequestType;
    onChange: (value: LeaveRequestType) => void;
    placeholder?: string;
    className?: string;
    testID?: string;
};

export function ReasonField({
    value,
    onChange,
    className,
    testID,
}: ReasonFieldProps) {
    const { t } = useTranslation();

    return (
        <select
            value={value}
            onChange={(event) =>
                onChange(event.target.value as LeaveRequestType)
            }
            className={cn(
                "border-input bg-background h-10 w-full rounded-md border px-3 text-sm leading-5 shadow-sm shadow-black/5",
                value ? "text-foreground" : "text-muted-foreground",
                className,
            )}
            data-testid={testID}
            aria-label={t("leave.selectReasonA11y")}
        >
            {LEAVE_REQUEST_TYPES.map((leaveType) => (
                <option key={leaveType} value={leaveType}>
                    {t(`leave.reasons.${leaveType}`)}
                </option>
            ))}
        </select>
    );
}
